import React, { useState } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import {
  Button,
  Form,
  Grid,
  Input,
  InputMask,
  Row,
  SimpleCollapse,
  SuccessModal
} from 'components'
import useToggle from 'hooks/useToggle'
import { useForm } from 'react-hook-form'
import { FORMAT, SPACING } from 'utils'
import * as Yup from 'yup'

import { EndPoint } from '../../Consolidation'
import ModalEditConsolidation from '../ModalEditConsolidation/ModalEditConsolidation'
import { ExecutivesTable } from './components/ExecutivesTable/ExecutivesTable'

// import { Container } from './styles';
interface IExecutivesCollapse {
  listDiretoriaExecutiva: any[]
  add: (data: any, type: EndPoint) => Promise<any>
  edit: (data: any, type: EndPoint) => void
  del: (id: number, type: EndPoint) => void
}

export interface ISelectedData {
  idDiretoriaConsolidacao: number
  dsDiretoriaConsolidacao: string
}

const schema = Yup.object({
  dsDiretoriaConsolidacao: Yup.string().required(
    'Diretoria Executiva é um campo obrigatório'
  )
})

const ExecutivesCollapse: React.FC<IExecutivesCollapse> = ({
  listDiretoriaExecutiva,
  add,
  del,
  edit
}) => {
  const typeEndpoint = 'E'
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })
  const [isEditing, toggleIsEditing] = useToggle()
  const [isDeleting, toggleIsDeleting] = useToggle()
  const [selectedData, setselectedData] = useState<ISelectedData | undefined>()

  const handleEdit = (data: any) => {
    edit(
      {
        dsDiretoriaConsolidacao: data.dsDiretoriaConsolidacao,
        idDiretoriaConsolidacao: selectedData.idDiretoriaConsolidacao
      },
      typeEndpoint
    )
    toggleIsEditing()
  }

  const handleSelectData = (objReq: any, type: 'D' | 'E') => {
    setselectedData(objReq)
    if (type === 'E') {
      isEditing === false && toggleIsEditing()
      return
    }

    if (type === 'D') {
      isEditing === false && toggleIsDeleting()
      return
    }
  }

  const handleAdd = (data) => {
    add(data, typeEndpoint).then(() => {
      reset({ dsDiretoriaConsolidacao: '' })
    })
  }

  return (
    <>
      <SimpleCollapse title="Diretoria Executiva">
        <Grid
          gridCols="2.5fr 0.4fr 5.5fr"
          gridGap={`0 ${SPACING.spacing20}`}
          margin={`${SPACING.spacing20} 0 ${SPACING.spacing30} 0`}
        >
          <Form onSubmit={handleSubmit(handleAdd)}>
            <Row>
              <InputMask
                control={control}
                errors={errors}
                formValue="dsDiretoriaConsolidacao"
                label="Diretoria Executiva"
                placeholder="Digite aqui..."
                maxLength={50}
                type="alfanumeric"
              />
              <Button text="+" type="submit" marginLeft={SPACING.spacing20} />
            </Row>
          </Form>
        </Grid>
        <ExecutivesTable
          tableData={listDiretoriaExecutiva}
          selectedData={handleSelectData}
        />
      </SimpleCollapse>
      {!!isEditing && (
        <ModalEditConsolidation
          isOpen={isEditing}
          onClose={toggleIsEditing}
          handleEdit={handleEdit}
          formValue="dsDiretoriaConsolidacao"
          initState={selectedData['dsDiretoriaConsolidacao']}
          title="Editar Empresa"
          validationSchema={schema}
        />
      )}
      {!!isDeleting && (
        <SuccessModal
          open={isDeleting}
          message="Tem certeza deseja deletar?"
          type="alert"
          txtButtonCancel="Voltar"
          txtButtonConfirm="SIM"
          handleCancel={toggleIsDeleting}
          handleConfirm={() => {
            del(selectedData.idDiretoriaConsolidacao, typeEndpoint)
            toggleIsDeleting()
          }}
        />
      )}
    </>
  )
}

export default ExecutivesCollapse
